/** 웨어러블 용도 — 알림용(관제) / 사용자용(회원 할당) */

export type WearableUsagePurpose = 'member' | 'safety_alert';

export const WEARABLE_USAGE_PURPOSE_OPTIONS: {
  value: WearableUsagePurpose;
  label: string;
}[] = [
  { value: 'member', label: '사용자용' },
  { value: 'safety_alert', label: '알림용' },
];

export const DEFAULT_WEARABLE_USAGE_PURPOSE: WearableUsagePurpose = 'member';

export function normalizeWearableUsagePurpose(
  raw?: string | null
): WearableUsagePurpose {
  const v = String(raw || '').trim().toLowerCase();
  return v === 'safety_alert' ? 'safety_alert' : 'member';
}

export function wearableUsagePurposeLabel(raw?: string | null): string {
  const p = normalizeWearableUsagePurpose(raw);
  return p === 'safety_alert' ? '알림용' : '사용자용';
}

export function isMemberUsageWearable(raw?: string | null): boolean {
  return normalizeWearableUsagePurpose(raw) === 'member';
}

export function isSafetyAlertUsageWearable(raw?: string | null): boolean {
  return normalizeWearableUsagePurpose(raw) === 'safety_alert';
}
